import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';

@Injectable()
export class MegamenuService {

  private urlBase = environment.backend.urlBase;
  
  private setHeadersJson(): HttpHeaders {
    const headerConfig = {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    };
    return new HttpHeaders(headerConfig);
  }

  private setHeadersXml(): HttpHeaders {
    const headerConfig = {
      'Content-Type': 'text/xml',
      'Accept': 'text/xml',
    };
    return new HttpHeaders(headerConfig);
  }
  constructor(private http: Http, private httpC: HttpClient) { }

  public getMegamenu(): Observable<any> {
    const url = `${this.urlBase}wp-json/wp/v2/megamenu_desktop`;
    console.log ("url :   ", url)
    return this.http.get(url);
  }

  public getMegamenuMobile(): Observable<any> {
    const url = `${this.urlBase}wp-json/wp/v2/megamenu_mobile`;
    console.log ("url :   ", url)
    return this.http.get(url);
  }
  
  private handleError(error: any): Observable<any> {
        console.error('Oops algo paso...', error);
        console.log(error.status);

        return Observable.throw(error.error || 'Server error');
   }

}

